export interface Notification {
  id: string;
  title: string;
  description: string;
  priority: "low" | "medium" | "high";
  status: string;
  icon: string;
  image: string | null;
  createdAt: { _seconds: number; _nanoseconds: number };
  isRead: boolean;
  /** Enlace asociado (p. ej. descarga de reporte listo) */
  url?: string | null;
}

// Helper para obtener el color de prioridad
export const getPriorityColor = (priority: string): string => {
  switch (priority) {
    case "high":
      return "bg-red-500";
    case "medium":
      return "bg-amber-500";
    case "low":
      return "bg-primary-500";
    default:
      return "bg-gray-400";
  }
};

// Helper para formatear tiempo relativo
export const getTimeAgo = (createdAt: {
  _seconds: number;
  _nanoseconds: number;
}): string => {
  if (!createdAt || !createdAt._seconds) return "";

  const now = Date.now();
  const notificationTime = createdAt._seconds * 1000;
  const diff = now - notificationTime;

  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 1) return "Ahora";
  if (minutes < 60) return `Hace ${minutes} minuto${minutes > 1 ? "s" : ""}`;
  if (hours < 24) return `Hace ${hours} hora${hours > 1 ? "s" : ""}`;
  if (days < 7) return `Hace ${days} día${days > 1 ? "s" : ""}`;

  const date = new Date(notificationTime);
  return date.toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};
